import type { Props } from './types.tsx';

export const UserIsOnboarded = ({ userIsOnboarded, children }: Props) =>
	userIsOnboarded === null ? null : children(userIsOnboarded);
